export default __webpack_public_path__ + "static/media/bw_photos_tikal-4.6d031369.jpg";